import WorkLogForm from "../workLogForm";
//--------------------------------------------------------------------------------------------
export default function InScopeWorkDiary({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Start Time", type: "time"}, 
        {title: "Stopped Time", type: "time"}, 
        {title: "Weather A.M.", nowrap: true, type: "select", options: ["clear", "cloudy", "rain", "wind"]}, 
        {title: "Weather P.M.", nowrap: true, type: "select", options: ["clear", "cloudy", "rain", "wind"]}, 
        {title: "Temperature A.M.", nowrap: true, type: "number"}, 
        {title: "Temperature P.M.", nowrap: true, type: "number"}, 
        {title: "Project", type: "text", default: rest.projectName},
        {title: "Date", type: "date"},
        {title: "Bess Utility Solutions In-Scope Work Diary", type: "textarea"},
        {title: "Subcontractors", type: "object", default: "[]", schema: [
            {title: "Name", type: "text"},
            {title: "Force", type: "text"},
            {title: "Location where working", type: "text"},
        ]}, 
        {title: "Equipments", type: "object", default: "[]", schema: [
            {title: "Eqpt. No.", type: "text"},
            {title: "Description", type: "text"},
        ]}, 
        {title: "3rd Party", type: "object", default: "[]", schema: [
            {title: "Tag Numbers", type: "text"},
            {title: "Description", type: "text"},
        ]}, 
        {title: "Safety Issues Or Events", type: "object", default: "[]", schema: [
            {title: "Foreman", type: "text"},
            {title: "Time", type: "date"},
            {title: "Description", type: "text"},
        ]}, 
        {title: "Foreman", type: "text"},
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            noPDF
            items = {items}
            {...rest}
        />
    )    
}